import * as api from '@/api/jxClass'
import * as TYPES from './type';

export default {
  // 教学班级
  async getClassList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqClassList(paramets)
    commit(TYPES.CLASS_LIST, {
      result
    })
    cb && cb()
  },
  async delClassById({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelClassById(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'del'
    })
    cb && cb()
  },
  async delBatchClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelBatchClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'del'
    })
    cb && cb()
  },
  async getUserByCId({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqUserByCId(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'user'
    })
    cb && cb()
  },
  async getjxClassStudent({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqjxClassStudent(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'student'
    })
    cb && cb()
  },


  async postAddStudentTojxClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqAddStudentTojxClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'addStu'
    })
    cb && cb()
  },
  async postEditStudentTojxClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqEditStudentTojxClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'addStu'
    })
    cb && cb()
  },
  async postDelStudentTojxClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelStudentTojxClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'delStu'
    })
    cb && cb()
  },
  // 教学班级
  async getClassList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqClassList(paramets)
    commit(TYPES.CLASS_LIST, {
      result
    })
    cb && cb()
  },
  // 教学班级学生
  async getClassStudentList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqClassStudentList(paramets)
    commit(TYPES.CLASS_STUDENT_LIST, {
      result
    })
    cb && cb()
  },
  // 教学班级分组
  async getClassGroupList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqClassGroupList(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'classGroup'
    })
    cb && cb()
  },
  // 批量分组
  async getBatchGroupStu({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqBatchGroupStu(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'batchGroup'
    })
    cb && cb()
  },
  // 随机分组
  async getBatchRandomStu({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqBatchRandomStu(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'randomStu'
    })
    cb && cb()
  },
  // 编辑+设置组长
  async editGroeupStuById({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqEditGroupStu(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'randomStu'
    })
    cb && cb()
  },
  //教学班级学生通过id删除
  async delClassStudentById({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelClassStudentById(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'delClassStu'
    })
    cb && cb()
  },
  //教学班级分组通过id删除
  async delClassGroupById({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelGroupById(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'delGroup'
    })
    cb && cb()
  },
  async delClassById({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelClassById(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'del'
    })
    cb && cb()
  },
  async delBatchClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelBatchClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'del'
    })
    cb && cb()
  },
  async delBatchClassGroupStu({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelBatchClassGroupStu(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'del'
    })
    cb && cb()
  },
  async getBasicClassList({
    commit,
    state
  }, cb) { //初始化页面获取行政班级和行政班级的学生
    const result = await api.reqBasicClassList()
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'basic'
    })
    cb && cb()
  },
  async getBasicClassEditList({
    commit,
    state
  }, {
    paramets,
    cb
  }) { //修改教学班级初始化页面获取行政班级和行政班级的学生和教学班级和教学班级学生
    const result = await api.reqBasicClassEditList(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'basicEdit'
    })
    cb && cb()
  },
  async getUserByCId({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqUserByCId(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'user'
    })
    cb && cb()
  },
  async getjxClassStudent({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqjxClassStudent(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'student'
    })
    cb && cb()
  },



  //教学班级分组-添加
  async postAddGroupTojxClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqAddGroupTojxClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'addGroup'
    })
    cb && cb()
  },
  //教学班级学生-单独分组
  async postJxGroupStudent({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqAddJxGroupStudent(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'addGroupStu'
    })
    cb && cb()
  },
  //教学班级分组-修改
  async postEditGroupTojxClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqEditGroupTojxClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'editGroup'
    })
    cb && cb()
  },
  async postDelStudentTojxClass({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqDelStudentTojxClass(paramets)
    commit(TYPES.CLASS_INFO, {
      result,
      type: 'delStu'
    })
    cb && cb()
  },
  //教学班级获取教室
  async reqGetclsOpts({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqGetclsOpts(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'opts'
    })
    cb && cb()
  },
  //教学班级绑定教室
  async reqAddclsOpts({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqAddclsOpts(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'add'
    })
    cb && cb()
  },
  //教学班级获取手写板
  async reqPadOpts({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqPadOpts(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'pad'
    })
    cb && cb()
  },
  //教学班级修改手写板
  async reqPadEdit({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqPadEdit(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'padEdit'
    })
    cb && cb()
  },
  //教学班级选择教室
  async reqChoCls({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqChoCls(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'choose'
    })
    cb && cb()
  },
  //解除手写板绑定
  async reqClearWacom({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqClearWacom(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'delWacom'
    })
    cb && cb()
  },
  //上课获取手写板数量
  async reqBoardCount({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqBoardCount(paramets)
    commit(TYPES.CLASS_WACOM, {
      result,
      type: 'count'
    })
    cb && cb()
  },
}
